import { PermissionResponse } from 'expo-camera'

import { PermissionStatus } from '../AskPermissionModal/types'

export const GRANTED_PERMISSION_RESPONSE: PermissionResponse = {
  status: PermissionStatus.GRANTED,
  granted: true,
  canAskAgain: true,
  expires: 'never',
}
export const UNDETERMINED_PERMISSION_RESPONSE: PermissionResponse = {
  status: PermissionStatus.UNDETERMINED,
  granted: false,
  canAskAgain: true,
  expires: 'never',
}
export const DENIED_PERMISSION_RESPONSE: PermissionResponse = {
  status: PermissionStatus.DENIED,
  granted: false,
  canAskAgain: true,
  expires: 'never',
}

export { VideoCall } from './VideoCall'
